var $3f0b33e7ccc65ae0$export$2e2bcd8739ae039 = crypto;
const $3f0b33e7ccc65ae0$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;


const $491757e359519ceb$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.digest(subtleDigest, data));
};
var $491757e359519ceb$export$2e2bcd8739ae039 = $491757e359519ceb$var$digest;


const $8c3dacf85b96b392$export$5486af06137bf21a = new TextEncoder();
const $8c3dacf85b96b392$export$124c96e6ce37090b = new TextDecoder();
const $8c3dacf85b96b392$var$MAX_INT32 = 2 ** 32;
function $8c3dacf85b96b392$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    buffers.forEach((buffer)=>{
        buf.set(buffer, i);
        i += buffer.length;
    });
    return buf;
}
function $8c3dacf85b96b392$export$256d3ca12372f112(alg, p2sInput) {
    return $8c3dacf85b96b392$export$ee1b3e54f0441b22($8c3dacf85b96b392$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $8c3dacf85b96b392$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $8c3dacf85b96b392$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$8c3dacf85b96b392$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $8c3dacf85b96b392$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $8c3dacf85b96b392$var$MAX_INT32);
    const low = value % $8c3dacf85b96b392$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, high, 0);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $8c3dacf85b96b392$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $8c3dacf85b96b392$var$writeUInt32BE(buf, value);
    return buf;
}
function $8c3dacf85b96b392$export$c1498c4a3718d967(input) {
    return $8c3dacf85b96b392$export$ee1b3e54f0441b22($8c3dacf85b96b392$export$74c16dba6c885532(input.length), input);
}
async function $8c3dacf85b96b392$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($8c3dacf85b96b392$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $491757e359519ceb$export$2e2bcd8739ae039)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}


const $54a6e0e463467b0a$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const $54a6e0e463467b0a$export$c564cdbbe6da493 = (input)=>{
    return $54a6e0e463467b0a$export$8fb536984ec8b4d7(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const $54a6e0e463467b0a$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $54a6e0e463467b0a$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return $54a6e0e463467b0a$export$94fdf11bafc8de6b(encoded);
    } catch (_a) {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};



class $599ac781534a947a$export$f754d6850d76bf87 extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        var _a;
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        (_a = Error.captureStackTrace) === null || _a === void 0 || _a.call(Error, this, this.constructor);
    }
}
class $599ac781534a947a$export$f1e14efb908196e9 extends $599ac781534a947a$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $599ac781534a947a$export$4b386bf852b7863d extends $599ac781534a947a$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $599ac781534a947a$export$d51fd7fedeccc338 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class $599ac781534a947a$export$19ddbcbf2016ab28 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class $599ac781534a947a$export$1a57512ad9773b2a extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class $599ac781534a947a$export$19f281f2275f6a15 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class $599ac781534a947a$export$e838de724af3d116 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class $599ac781534a947a$export$936b39ada0bbfceb extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class $599ac781534a947a$export$b3992e0f88fb07e3 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class $599ac781534a947a$export$9b22c2a1e2403b8e extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class $599ac781534a947a$export$3d5ed1a538bed04e extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class $599ac781534a947a$export$dc036de401a5c284 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class $599ac781534a947a$export$3f30acebf25c04e6 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class $599ac781534a947a$export$c67a0218e7c50378 extends $599ac781534a947a$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}




var $add6505a95ba3e92$export$2e2bcd8739ae039 = (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).getRandomValues.bind((0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039));


function $da503c283075069a$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
        case "A128GCMKW":
        case "A192GCM":
        case "A192GCMKW":
        case "A256GCM":
        case "A256GCMKW":
            return 96;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            return 128;
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $da503c283075069a$export$2e2bcd8739ae039 = (alg)=>(0, $add6505a95ba3e92$export$2e2bcd8739ae039)(new Uint8Array($da503c283075069a$export$db433e85ac514a95(alg) >> 3));


const $25dfb6cac6481cac$var$checkIvLength = (enc, iv)=>{
    if (iv.length << 3 !== (0, $da503c283075069a$export$db433e85ac514a95)(enc)) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("Invalid Initialization Vector length");
};
var $25dfb6cac6481cac$export$2e2bcd8739ae039 = $25dfb6cac6481cac$var$checkIvLength;



const $49ddc742411ee52a$var$checkCekLength = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};
var $49ddc742411ee52a$export$2e2bcd8739ae039 = $49ddc742411ee52a$var$checkCekLength;


const $2d83d0a97460fa37$var$timingSafeEqual = (a, b)=>{
    if (!(a instanceof Uint8Array)) throw new TypeError("First argument must be a buffer");
    if (!(b instanceof Uint8Array)) throw new TypeError("Second argument must be a buffer");
    if (a.length !== b.length) throw new TypeError("Input buffers must have the same length");
    const len = a.length;
    let out = 0;
    let i = -1;
    while(++i < len)out |= a[i] ^ b[i];
    return out === 0;
};
var $2d83d0a97460fa37$export$2e2bcd8739ae039 = $2d83d0a97460fa37$var$timingSafeEqual;




function $5852df024b41aa91$export$7b262397cadac19f() {
    return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}


function $bd0b36fb17abf4f5$var$unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $bd0b36fb17abf4f5$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $bd0b36fb17abf4f5$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $bd0b36fb17abf4f5$var$getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function $bd0b36fb17abf4f5$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $bd0b36fb17abf4f5$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "HMAC")) throw $bd0b36fb17abf4f5$var$unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw $bd0b36fb17abf4f5$var$unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "RSA-PSS")) throw $bd0b36fb17abf4f5$var$unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") {
                if ((0, $5852df024b41aa91$export$7b262397cadac19f)()) {
                    if ($bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "NODE-ED25519")) break;
                    throw $bd0b36fb17abf4f5$var$unusable("Ed25519, Ed448, or NODE-ED25519");
                }
                throw $bd0b36fb17abf4f5$var$unusable("Ed25519 or Ed448");
            }
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "ECDSA")) throw $bd0b36fb17abf4f5$var$unusable("ECDSA");
                const expected = $bd0b36fb17abf4f5$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $bd0b36fb17abf4f5$var$checkUsage(key, usages);
}
function $bd0b36fb17abf4f5$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "AES-GCM")) throw $bd0b36fb17abf4f5$var$unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "AES-KW")) throw $bd0b36fb17abf4f5$var$unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw $bd0b36fb17abf4f5$var$unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "PBKDF2")) throw $bd0b36fb17abf4f5$var$unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!$bd0b36fb17abf4f5$var$isAlgorithm(key.algorithm, "RSA-OAEP")) throw $bd0b36fb17abf4f5$var$unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $bd0b36fb17abf4f5$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $bd0b36fb17abf4f5$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $bd0b36fb17abf4f5$var$checkUsage(key, usages);
}


function $233e587bc0c17441$var$message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor && actual.constructor.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $233e587bc0c17441$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $233e587bc0c17441$var$message("Key must be ", actual, ...types);
};
function $233e587bc0c17441$export$e94f758d09bc1828(alg, actual, ...types) {
    return $233e587bc0c17441$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}



var $002bdc4a0215a55c$export$2e2bcd8739ae039 = (key)=>{
    return (0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key);
};
const $002bdc4a0215a55c$export$b14ad400b1d09e0f = [
    "CryptoKey"
];


async function $8e3c9f32bae103db$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "decrypt"
    ]);
    const macKey = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const macData = (0, $8c3dacf85b96b392$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $8c3dacf85b96b392$export$e7b531e00a18fdd7)(aad.length << 3));
    const expectedTag = new Uint8Array((await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = (0, $2d83d0a97460fa37$export$2e2bcd8739ae039)(tag, expectedTag);
    } catch (_a) {}
    if (!macCheckPassed) throw new (0, $599ac781534a947a$export$1a57512ad9773b2a)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.decrypt({
            iv: iv,
            name: "AES-CBC"
        }, encKey, ciphertext));
    } catch (_b) {}
    if (!plaintext) throw new (0, $599ac781534a947a$export$1a57512ad9773b2a)();
    return plaintext;
}
async function $8e3c9f32bae103db$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "decrypt"
    ]);
    else {
        (0, $bd0b36fb17abf4f5$export$41a67f89f6678b35)(cek, enc, "decrypt");
        encKey = cek;
    }
    try {
        return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: "AES-GCM",
            tagLength: 128
        }, encKey, (0, $8c3dacf85b96b392$export$ee1b3e54f0441b22)(ciphertext, tag)));
    } catch (_a) {
        throw new (0, $599ac781534a947a$export$1a57512ad9773b2a)();
    }
}
const $8e3c9f32bae103db$var$decrypt = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(cek, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), "Uint8Array"));
    (0, $25dfb6cac6481cac$export$2e2bcd8739ae039)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $49ddc742411ee52a$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $8e3c9f32bae103db$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $49ddc742411ee52a$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $8e3c9f32bae103db$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $8e3c9f32bae103db$export$2e2bcd8739ae039 = $8e3c9f32bae103db$var$decrypt;



const $183cd4e96b76501e$export$cae1ce83fe4a1782 = async ()=>{
    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported by your javascript runtime. You need to use the `inflateRaw` decrypt option to provide Inflate Raw implementation.');
};
const $183cd4e96b76501e$export$2316623ecd1285ab = async ()=>{
    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported by your javascript runtime. You need to use the `deflateRaw` encrypt option to provide Deflate Raw implementation.');
};



const $751ed1ebc64f8b96$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $751ed1ebc64f8b96$export$2e2bcd8739ae039 = $751ed1ebc64f8b96$var$isDisjoint;


function $319a04fbce04ffdb$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $319a04fbce04ffdb$export$2e2bcd8739ae039(input) {
    if (!$319a04fbce04ffdb$var$isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}


const $4947afff5b50c769$var$bogusWebCrypto = [
    {
        hash: "SHA-256",
        name: "HMAC"
    },
    true,
    [
        "sign"
    ]
];
var $4947afff5b50c769$export$2e2bcd8739ae039 = $4947afff5b50c769$var$bogusWebCrypto;






function $224272b9dcd7f753$var$checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function $224272b9dcd7f753$var$getCryptoKey(key, alg, usage) {
    if ((0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) {
        (0, $bd0b36fb17abf4f5$export$41a67f89f6678b35)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", key, "AES-KW", true, [
        usage
    ]);
    throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), "Uint8Array"));
}
const $224272b9dcd7f753$export$4997ffc0176396a6 = async (alg, key, cek)=>{
    const cryptoKey = await $224272b9dcd7f753$var$getCryptoKey(key, alg, "wrapKey");
    $224272b9dcd7f753$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $4947afff5b50c769$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, cryptoKey, "AES-KW"));
};
const $224272b9dcd7f753$export$debb760848ca95a = async (alg, key, encryptedKey)=>{
    const cryptoKey = await $224272b9dcd7f753$var$getCryptoKey(key, alg, "unwrapKey");
    $224272b9dcd7f753$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, cryptoKey, "AES-KW", ...(0, $4947afff5b50c769$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
};







async function $44ac2949c0fdd669$export$87770b6b245073b5(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(publicKey)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(publicKey, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
    (0, $bd0b36fb17abf4f5$export$41a67f89f6678b35)(publicKey, "ECDH");
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(privateKey)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(privateKey, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
    (0, $bd0b36fb17abf4f5$export$41a67f89f6678b35)(privateKey, "ECDH", "deriveBits");
    const value = (0, $8c3dacf85b96b392$export$ee1b3e54f0441b22)((0, $8c3dacf85b96b392$export$c1498c4a3718d967)((0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(algorithm)), (0, $8c3dacf85b96b392$export$c1498c4a3718d967)(apu), (0, $8c3dacf85b96b392$export$c1498c4a3718d967)(apv), (0, $8c3dacf85b96b392$export$74c16dba6c885532)(keyLength));
    let length;
    if (publicKey.algorithm.name === "X25519") length = 256;
    else if (publicKey.algorithm.name === "X448") length = 448;
    else length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
    const sharedSecret = new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, length));
    return (0, $8c3dacf85b96b392$export$67163693c21af44f)(sharedSecret, keyLength, value);
}
async function $44ac2949c0fdd669$export$1338dee8c889e310(key) {
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
    return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.generateKey(key.algorithm, true, [
        "deriveBits"
    ]);
}
function $44ac2949c0fdd669$export$f28ab77d793719b2(key) {
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
    return [
        "P-256",
        "P-384",
        "P-521"
    ].includes(key.algorithm.namedCurve) || key.algorithm.name === "X25519" || key.algorithm.name === "X448";
}







function $6509599917539a0f$export$2e2bcd8739ae039(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("PBES2 Salt Input must be 8 or more octets");
}






function $4c1ef315ddeae8f1$var$getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", key, "PBKDF2", false, [
        "deriveBits"
    ]);
    if ((0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) {
        (0, $bd0b36fb17abf4f5$export$41a67f89f6678b35)(key, alg, "deriveBits", "deriveKey");
        return key;
    }
    throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), "Uint8Array"));
}
async function $4c1ef315ddeae8f1$var$deriveKey(p2s, alg, p2c, key) {
    (0, $6509599917539a0f$export$2e2bcd8739ae039)(p2s);
    const salt = (0, $8c3dacf85b96b392$export$256d3ca12372f112)(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: "PBKDF2",
        salt: salt
    };
    const wrapAlg = {
        length: keylen,
        name: "AES-KW"
    };
    const cryptoKey = await $4c1ef315ddeae8f1$var$getCryptoKey(key, alg);
    if (cryptoKey.usages.includes("deriveBits")) return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.deriveBits(subtleAlg, cryptoKey, keylen));
    if (cryptoKey.usages.includes("deriveKey")) return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, [
        "wrapKey",
        "unwrapKey"
    ]);
    throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const $4c1ef315ddeae8f1$export$5b0f6292f11d1d18 = async (alg, key, cek, p2c = 2048, p2s = (0, $add6505a95ba3e92$export$2e2bcd8739ae039)(new Uint8Array(16)))=>{
    const derived = await $4c1ef315ddeae8f1$var$deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await (0, $224272b9dcd7f753$export$4997ffc0176396a6)(alg.slice(-6), derived, cek);
    return {
        encryptedKey: encryptedKey,
        p2c: p2c,
        p2s: (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(p2s)
    };
};
const $4c1ef315ddeae8f1$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey, p2c, p2s)=>{
    const derived = await $4c1ef315ddeae8f1$var$deriveKey(p2s, alg, p2c, key);
    return (0, $224272b9dcd7f753$export$debb760848ca95a)(alg.slice(-6), derived, encryptedKey);
};



function $46fa41cd273de294$export$2e2bcd8739ae039(alg) {
    switch(alg){
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            return "RSA-OAEP";
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}





var $2c8180cef663e103$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};




const $a05561e091e16287$export$5b0f6292f11d1d18 = async (alg, key, cek)=>{
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
    (0, $bd0b36fb17abf4f5$export$41a67f89f6678b35)(key, alg, "encrypt", "wrapKey");
    (0, $2c8180cef663e103$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("encrypt")) return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.encrypt((0, $46fa41cd273de294$export$2e2bcd8739ae039)(alg), key, cek));
    if (key.usages.includes("wrapKey")) {
        const cryptoKeyCek = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $4947afff5b50c769$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, key, (0, $46fa41cd273de294$export$2e2bcd8739ae039)(alg)));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
const $a05561e091e16287$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey)=>{
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
    (0, $bd0b36fb17abf4f5$export$41a67f89f6678b35)(key, alg, "decrypt", "unwrapKey");
    (0, $2c8180cef663e103$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("decrypt")) return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.decrypt((0, $46fa41cd273de294$export$2e2bcd8739ae039)(alg), key, encryptedKey));
    if (key.usages.includes("unwrapKey")) {
        const cryptoKeyCek = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, key, (0, $46fa41cd273de294$export$2e2bcd8739ae039)(alg), ...(0, $4947afff5b50c769$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
};






function $723ad0955c3ec8bb$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
            return 128;
        case "A192GCM":
            return 192;
        case "A256GCM":
        case "A128CBC-HS256":
            return 256;
        case "A192CBC-HS384":
            return 384;
        case "A256CBC-HS512":
            return 512;
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $723ad0955c3ec8bb$export$2e2bcd8739ae039 = (alg)=>(0, $add6505a95ba3e92$export$2e2bcd8739ae039)(new Uint8Array($723ad0955c3ec8bb$export$db433e85ac514a95(alg) >> 3));







var $9ffaef5451229e15$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};




const $b876728f20516af6$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $9ffaef5451229e15$export$2e2bcd8739ae039)((0, $54a6e0e463467b0a$export$8fb536984ec8b4d7)(new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $b876728f20516af6$export$cfba7e924fe414ca = (key)=>{
    return $b876728f20516af6$var$genericExport("public", "spki", key);
};
const $b876728f20516af6$export$cac76a78a90b914d = (key)=>{
    return $b876728f20516af6$var$genericExport("private", "pkcs8", key);
};
const $b876728f20516af6$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    let i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $b876728f20516af6$var$findOid(keyData, oid, i + 1);
};
const $b876728f20516af6$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $b876728f20516af6$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case $b876728f20516af6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const $b876728f20516af6$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    var _a, _b;
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = $b876728f20516af6$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: $b876728f20516af6$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (Algorithm) value');
    }
    try {
        return await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey(keyFormat, keyData, algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages);
    } catch (err) {
        if (algorithm.name === "Ed25519" && (err === null || err === void 0 ? void 0 : err.name) === "NotSupportedError" && (0, $5852df024b41aa91$export$7b262397cadac19f)()) {
            algorithm = {
                name: "NODE-ED25519",
                namedCurve: "NODE-ED25519"
            };
            return await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey(keyFormat, keyData, algorithm, (_b = options === null || options === void 0 ? void 0 : options.extractable) !== null && _b !== void 0 ? _b : false, keyUsages);
        }
        throw err;
    }
};
const $b876728f20516af6$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $b876728f20516af6$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const $b876728f20516af6$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $b876728f20516af6$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function $b876728f20516af6$var$getElement(seq) {
    let result = [];
    let next = 0;
    while(next < seq.length){
        let nextPart = $b876728f20516af6$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $b876728f20516af6$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        let numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $b876728f20516af6$var$spkiFromX509(buf) {
    const tbsCertificate = $b876728f20516af6$var$getElement($b876728f20516af6$var$getElement($b876728f20516af6$var$parseElement(buf).contents)[0].contents);
    return (0, $54a6e0e463467b0a$export$8fb536984ec8b4d7)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $b876728f20516af6$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, $54a6e0e463467b0a$export$94fdf11bafc8de6b)(pem);
    return (0, $9ffaef5451229e15$export$2e2bcd8739ae039)($b876728f20516af6$var$spkiFromX509(raw), "PUBLIC KEY");
}
const $b876728f20516af6$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $b876728f20516af6$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError("failed to parse the X.509 certificate", {
            cause: cause
        });
    }
    return $b876728f20516af6$export$f9a3505cdaa1fb3e(spki, alg, options);
};






function $337343867c42a494$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "oct":
            switch(jwk.alg){
                case "HS256":
                case "HS384":
                case "HS512":
                    algorithm = {
                        name: "HMAC",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = [
                        "sign",
                        "verify"
                    ];
                    break;
                case "A128CBC-HS256":
                case "A192CBC-HS384":
                case "A256CBC-HS512":
                    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)(`${jwk.alg} keys cannot be imported as CryptoKey instances`);
                case "A128GCM":
                case "A192GCM":
                case "A256GCM":
                case "A128GCMKW":
                case "A192GCMKW":
                case "A256GCMKW":
                    algorithm = {
                        name: "AES-GCM"
                    };
                    keyUsages = [
                        "encrypt",
                        "decrypt"
                    ];
                    break;
                case "A128KW":
                case "A192KW":
                case "A256KW":
                    algorithm = {
                        name: "AES-KW"
                    };
                    keyUsages = [
                        "wrapKey",
                        "unwrapKey"
                    ];
                    break;
                case "PBES2-HS256+A128KW":
                case "PBES2-HS384+A192KW":
                case "PBES2-HS512+A256KW":
                    algorithm = {
                        name: "PBKDF2"
                    };
                    keyUsages = [
                        "deriveBits"
                    ];
                    break;
                default:
                    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $337343867c42a494$var$parse = async (jwk)=>{
    var _a, _b;
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $337343867c42a494$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        (_a = jwk.ext) !== null && _a !== void 0 ? _a : false,
        (_b = jwk.key_ops) !== null && _b !== void 0 ? _b : keyUsages
    ];
    if (algorithm.name === "PBKDF2") return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jwk.k), ...rest);
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    try {
        return await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("jwk", keyData, ...rest);
    } catch (err) {
        if (algorithm.name === "Ed25519" && (err === null || err === void 0 ? void 0 : err.name) === "NotSupportedError" && (0, $5852df024b41aa91$export$7b262397cadac19f)()) {
            rest[0] = {
                name: "NODE-ED25519",
                namedCurve: "NODE-ED25519"
            };
            return await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("jwk", keyData, ...rest);
        }
        throw err;
    }
};
var $337343867c42a494$export$2e2bcd8739ae039 = $337343867c42a494$var$parse;




async function $d3f3b992c534ed5a$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $b876728f20516af6$export$f9a3505cdaa1fb3e)(spki, alg, options);
}
async function $d3f3b992c534ed5a$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $b876728f20516af6$export$ed788b6a8533858f)(x509, alg, options);
}
async function $d3f3b992c534ed5a$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $b876728f20516af6$export$224b0a6339c7267f)(pkcs8, alg, options);
}
async function $d3f3b992c534ed5a$export$2b70d37b4d0b888b(jwk, alg, octAsKeyObject) {
    var _a;
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            octAsKeyObject !== null && octAsKeyObject !== void 0 ? octAsKeyObject : octAsKeyObject = jwk.ext !== true;
            if (octAsKeyObject) return (0, $337343867c42a494$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg,
                ext: (_a = jwk.ext) !== null && _a !== void 0 ? _a : false
            });
            return (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, $337343867c42a494$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Unsupported "kty" (Key Type) Parameter value');
    }
}




const $8a5b1565e0dee973$var$symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, $002bdc4a0215a55c$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $233e587bc0c17441$export$e94f758d09bc1828)(alg, key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f).join(" or ")} instances for symmetric algorithms must be of type "secret"`);
};
const $8a5b1565e0dee973$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, $002bdc4a0215a55c$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $233e587bc0c17441$export$e94f758d09bc1828)(alg, key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
    if (key.type === "secret") throw new TypeError(`${(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
};
const $8a5b1565e0dee973$var$checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $8a5b1565e0dee973$var$symmetricTypeCheck(alg, key);
    else $8a5b1565e0dee973$var$asymmetricTypeCheck(alg, key, usage);
};
var $8a5b1565e0dee973$export$2e2bcd8739ae039 = $8a5b1565e0dee973$var$checkKeyType;











async function $ae680723017e3689$var$cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "encrypt"
    ]);
    const macKey = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const ciphertext = new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.encrypt({
        iv: iv,
        name: "AES-CBC"
    }, encKey, plaintext));
    const macData = (0, $8c3dacf85b96b392$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $8c3dacf85b96b392$export$e7b531e00a18fdd7)(aad.length << 3));
    const tag = new Uint8Array((await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
async function $ae680723017e3689$var$gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "encrypt"
    ]);
    else {
        (0, $bd0b36fb17abf4f5$export$41a67f89f6678b35)(cek, enc, "encrypt");
        encKey = cek;
    }
    const encrypted = new Uint8Array(await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.encrypt({
        additionalData: aad,
        iv: iv,
        name: "AES-GCM",
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
const $ae680723017e3689$var$encrypt = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(cek, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), "Uint8Array"));
    (0, $25dfb6cac6481cac$export$2e2bcd8739ae039)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $49ddc742411ee52a$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $ae680723017e3689$var$cbcEncrypt(enc, plaintext, cek, iv, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $49ddc742411ee52a$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $ae680723017e3689$var$gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $ae680723017e3689$export$2e2bcd8739ae039 = $ae680723017e3689$var$encrypt;





async function $c4131030fcf4d460$export$4997ffc0176396a6(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    iv || (iv = (0, $da503c283075069a$export$2e2bcd8739ae039)(jweAlgorithm));
    const { ciphertext: encryptedKey, tag: tag } = await (0, $ae680723017e3689$export$2e2bcd8739ae039)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey: encryptedKey,
        iv: (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(iv),
        tag: (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(tag)
    };
}
async function $c4131030fcf4d460$export$debb760848ca95a(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, $8e3c9f32bae103db$export$2e2bcd8739ae039)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}


async function $491143ea092c3ec9$var$decryptKeyManagement(alg, key, encryptedKey, joseHeader, options) {
    (0, $8a5b1565e0dee973$export$2e2bcd8739ae039)(alg, key, "decrypt");
    switch(alg){
        case "dir":
            if (encryptedKey !== undefined) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
            return key;
        case "ECDH-ES":
            if (encryptedKey !== undefined) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(joseHeader.epk)) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                if (!$44ac2949c0fdd669$export$f28ab77d793719b2(key)) throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const epk = await (0, $d3f3b992c534ed5a$export$2b70d37b4d0b888b)(joseHeader.epk, alg);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    partyUInfo = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(joseHeader.apu);
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    partyVInfo = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(joseHeader.apv);
                }
                const sharedSecret = await $44ac2949c0fdd669$export$87770b6b245073b5(epk, key, alg === "ECDH-ES" ? joseHeader.enc : alg, alg === "ECDH-ES" ? (0, $723ad0955c3ec8bb$export$db433e85ac514a95)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === "ECDH-ES") return sharedSecret;
                if (encryptedKey === undefined) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                return (0, $224272b9dcd7f753$export$debb760848ca95a)(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            if (encryptedKey === undefined) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $a05561e091e16287$export$e85a0c9a1067c5d3)(alg, key, encryptedKey);
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                if (encryptedKey === undefined) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.p2c !== "number") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = (options === null || options === void 0 ? void 0 : options.maxPBES2Count) || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                return (0, $4c1ef315ddeae8f1$export$e85a0c9a1067c5d3)(alg, key, encryptedKey, joseHeader.p2c, (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(joseHeader.p2s));
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            if (encryptedKey === undefined) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $224272b9dcd7f753$export$debb760848ca95a)(alg, key, encryptedKey);
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                if (encryptedKey === undefined) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.iv !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                const iv = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(joseHeader.iv);
                const tag = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(joseHeader.tag);
                return (0, $c4131030fcf4d460$export$debb760848ca95a)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
}
var $491143ea092c3ec9$export$2e2bcd8739ae039 = $491143ea092c3ec9$var$decryptKeyManagement;





function $0b572ece71b785f0$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        else if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $0b572ece71b785f0$export$2e2bcd8739ae039 = $0b572ece71b785f0$var$validateCrit;


const $33550bd8f4719411$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $33550bd8f4719411$export$2e2bcd8739ae039 = $33550bd8f4719411$var$validateAlgorithms;


async function $04c938c2900bb1d1$export$b75cd12892ae94d2(jwe, key, options) {
    var _a;
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jwe)) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("Flattened JWE must be an object");
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JOSE Header missing");
    if (typeof jwe.iv !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Initialization Vector missing or incorrect type");
    if (typeof jwe.ciphertext !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Ciphertext missing or incorrect type");
    if (typeof jwe.tag !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Authentication Tag missing or incorrect type");
    if (jwe.protected !== undefined && typeof jwe.protected !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Protected Header incorrect type");
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Encrypted Key incorrect type");
    if (jwe.aad !== undefined && typeof jwe.aad !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE AAD incorrect type");
    if (jwe.header !== undefined && !(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jwe.header)) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Shared Unprotected Header incorrect type");
    if (jwe.unprotected !== undefined && !(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jwe.unprotected)) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Per-Recipient Unprotected Header incorrect type");
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jwe.protected);
        parsedProt = JSON.parse((0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(protectedHeader));
    } catch (_b) {
        throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Protected Header is invalid");
    }
    if (!(0, $751ed1ebc64f8b96$export$2e2bcd8739ae039)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, $0b572ece71b785f0$export$2e2bcd8739ae039)((0, $599ac781534a947a$export$19f281f2275f6a15), new Map(), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) {
        if (!parsedProt || !parsedProt.zip) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
        if (joseHeader.zip !== "DEF") throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');
    }
    const { alg: alg, enc: enc } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("missing JWE Algorithm (alg) in JWE Header");
    if (typeof enc !== "string" || !enc) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("missing JWE Encryption Algorithm (enc) in JWE Header");
    const keyManagementAlgorithms = options && (0, $33550bd8f4719411$export$2e2bcd8739ae039)("keyManagementAlgorithms", options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, $33550bd8f4719411$export$2e2bcd8739ae039)("contentEncryptionAlgorithms", options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg)) throw new (0, $599ac781534a947a$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, $599ac781534a947a$export$d51fd7fedeccc338)('"enc" (Encryption Algorithm) Header Parameter not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) encryptedKey = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jwe.encrypted_key);
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    let cek;
    try {
        cek = await (0, $491143ea092c3ec9$export$2e2bcd8739ae039)(alg, key, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, $599ac781534a947a$export$19f281f2275f6a15) || err instanceof (0, $599ac781534a947a$export$19ddbcbf2016ab28)) throw err;
        cek = (0, $723ad0955c3ec8bb$export$2e2bcd8739ae039)(enc);
    }
    const iv = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jwe.iv);
    const tag = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jwe.tag);
    const protectedHeader = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode((_a = jwe.protected) !== null && _a !== void 0 ? _a : "");
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, $8c3dacf85b96b392$export$ee1b3e54f0441b22)(protectedHeader, (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode("."), (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(jwe.aad));
    else additionalData = protectedHeader;
    let plaintext = await (0, $8e3c9f32bae103db$export$2e2bcd8739ae039)(enc, cek, (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jwe.ciphertext), iv, tag, additionalData);
    if (joseHeader.zip === "DEF") plaintext = await ((options === null || options === void 0 ? void 0 : options.inflateRaw) || (0, $183cd4e96b76501e$export$cae1ce83fe4a1782))(plaintext);
    const result = {
        plaintext: plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) result.additionalAuthenticatedData = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jwe.aad);
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $1b1a9f568583dcab$export$c9a8efe6bfd872ce(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(jwe);
    if (typeof jwe !== "string") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("Compact JWE must be a string or Uint8Array");
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length: length } = jwe.split(".");
    if (length !== 5) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("Invalid Compact JWE");
    const decrypted = await (0, $04c938c2900bb1d1$export$b75cd12892ae94d2)({
        ciphertext: ciphertext,
        iv: iv || undefined,
        protected: protectedHeader || undefined,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}






async function $e95577fc4034f34a$export$56bc728c88264430(jwe, key, options) {
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jwe)) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("General JWE must be an object");
    if (!Array.isArray(jwe.recipients) || !jwe.recipients.every((0, $319a04fbce04ffdb$export$2e2bcd8739ae039))) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Recipients missing or incorrect type");
    if (!jwe.recipients.length) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Recipients has no members");
    for (const recipient of jwe.recipients)try {
        return await (0, $04c938c2900bb1d1$export$b75cd12892ae94d2)({
            aad: jwe.aad,
            ciphertext: jwe.ciphertext,
            encrypted_key: recipient.encrypted_key,
            header: recipient.header,
            iv: jwe.iv,
            protected: jwe.protected,
            tag: jwe.tag,
            unprotected: jwe.unprotected
        }, key, options);
    } catch (_a) {}
    throw new (0, $599ac781534a947a$export$1a57512ad9773b2a)();
}


















const $891135ce5ed081a3$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(key)
    };
    if (!(0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.exportKey("jwk", key);
    return jwk;
};
var $891135ce5ed081a3$export$2e2bcd8739ae039 = $891135ce5ed081a3$var$keyToJWK;


async function $9ee02072b0883f32$export$7f687badbeed246d(key) {
    return (0, $b876728f20516af6$export$cfba7e924fe414ca)(key);
}
async function $9ee02072b0883f32$export$ba4a7192ac1a47fe(key) {
    return (0, $b876728f20516af6$export$cac76a78a90b914d)(key);
}
async function $9ee02072b0883f32$export$ffb510cfd482ce82(key) {
    return (0, $891135ce5ed081a3$export$2e2bcd8739ae039)(key);
}




async function $b0cae4bcf42b1576$var$encryptKeyManagement(alg, enc, key, providedCek, providedParameters = {}) {
    let encryptedKey;
    let parameters;
    let cek;
    (0, $8a5b1565e0dee973$export$2e2bcd8739ae039)(alg, key, "encrypt");
    switch(alg){
        case "dir":
            cek = key;
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!$44ac2949c0fdd669$export$f28ab77d793719b2(key)) throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const { apu: apu, apv: apv } = providedParameters;
                let { epk: ephemeralKey } = providedParameters;
                ephemeralKey || (ephemeralKey = (await $44ac2949c0fdd669$export$1338dee8c889e310(key)).privateKey);
                const { x: x, y: y, crv: crv, kty: kty } = await (0, $9ee02072b0883f32$export$ffb510cfd482ce82)(ephemeralKey);
                const sharedSecret = await $44ac2949c0fdd669$export$87770b6b245073b5(key, ephemeralKey, alg === "ECDH-ES" ? enc : alg, alg === "ECDH-ES" ? (0, $723ad0955c3ec8bb$export$db433e85ac514a95)(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
                parameters = {
                    epk: {
                        x: x,
                        crv: crv,
                        kty: kty
                    }
                };
                if (kty === "EC") parameters.epk.y = y;
                if (apu) parameters.apu = (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(apu);
                if (apv) parameters.apv = (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(apv);
                if (alg === "ECDH-ES") {
                    cek = sharedSecret;
                    break;
                }
                cek = providedCek || (0, $723ad0955c3ec8bb$export$2e2bcd8739ae039)(enc);
                const kwAlg = alg.slice(-6);
                encryptedKey = await (0, $224272b9dcd7f753$export$4997ffc0176396a6)(kwAlg, sharedSecret, cek);
                break;
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            cek = providedCek || (0, $723ad0955c3ec8bb$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $a05561e091e16287$export$5b0f6292f11d1d18)(alg, key, cek);
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                cek = providedCek || (0, $723ad0955c3ec8bb$export$2e2bcd8739ae039)(enc);
                const { p2c: p2c, p2s: p2s } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $4c1ef315ddeae8f1$export$5b0f6292f11d1d18)(alg, key, cek, p2c, p2s));
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            cek = providedCek || (0, $723ad0955c3ec8bb$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $224272b9dcd7f753$export$4997ffc0176396a6)(alg, key, cek);
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                cek = providedCek || (0, $723ad0955c3ec8bb$export$2e2bcd8739ae039)(enc);
                const { iv: iv } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $c4131030fcf4d460$export$4997ffc0176396a6)(alg, key, cek, iv));
                break;
            }
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
    return {
        cek: cek,
        encryptedKey: encryptedKey,
        parameters: parameters
    };
}
var $b0cae4bcf42b1576$export$2e2bcd8739ae039 = $b0cae4bcf42b1576$var$encryptKeyManagement;






const $9d1c699dfcbf8bf8$export$39c45cb77eaf132 = Symbol();
class $9d1c699dfcbf8bf8$export$eec23736d3c24809 {
    constructor(plaintext){
        if (!(plaintext instanceof Uint8Array)) throw new TypeError("plaintext must be an instance of Uint8Array");
        this._plaintext = plaintext;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._sharedUnprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._sharedUnprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    async encrypt(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
        if (!(0, $751ed1ebc64f8b96$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader,
            ...this._sharedUnprotectedHeader
        };
        (0, $0b572ece71b785f0$export$2e2bcd8739ae039)((0, $599ac781534a947a$export$19f281f2275f6a15), new Map(), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
        if (joseHeader.zip !== undefined) {
            if (!this._protectedHeader || !this._protectedHeader.zip) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
            if (joseHeader.zip !== "DEF") throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');
        }
        const { alg: alg, enc: enc } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
        if (typeof enc !== "string" || !enc) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
        let encryptedKey;
        if (alg === "dir") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Encryption");
        } else if (alg === "ECDH-ES") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Key Agreement");
        }
        let cek;
        {
            let parameters;
            ({ cek: cek, encryptedKey: encryptedKey, parameters: parameters } = await (0, $b0cae4bcf42b1576$export$2e2bcd8739ae039)(alg, enc, key, this._cek, this._keyManagementParameters));
            if (parameters) {
                if (options && $9d1c699dfcbf8bf8$export$39c45cb77eaf132 in options) {
                    if (!this._unprotectedHeader) this.setUnprotectedHeader(parameters);
                    else this._unprotectedHeader = {
                        ...this._unprotectedHeader,
                        ...parameters
                    };
                } else if (!this._protectedHeader) this.setProtectedHeader(parameters);
                else this._protectedHeader = {
                    ...this._protectedHeader,
                    ...parameters
                };
            }
        }
        this._iv || (this._iv = (0, $da503c283075069a$export$2e2bcd8739ae039)(enc));
        let additionalData;
        let protectedHeader;
        let aadMember;
        if (this._protectedHeader) protectedHeader = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode((0, $54a6e0e463467b0a$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode("");
        if (this._aad) {
            aadMember = (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(this._aad);
            additionalData = (0, $8c3dacf85b96b392$export$ee1b3e54f0441b22)(protectedHeader, (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode("."), (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(aadMember));
        } else additionalData = protectedHeader;
        let ciphertext;
        let tag;
        if (joseHeader.zip === "DEF") {
            const deflated = await ((options === null || options === void 0 ? void 0 : options.deflateRaw) || (0, $183cd4e96b76501e$export$2316623ecd1285ab))(this._plaintext);
            ({ ciphertext: ciphertext, tag: tag } = await (0, $ae680723017e3689$export$2e2bcd8739ae039)(enc, deflated, cek, this._iv, additionalData));
        } else ({ ciphertext: ciphertext, tag: tag } = await (0, $ae680723017e3689$export$2e2bcd8739ae039)(enc, this._plaintext, cek, this._iv, additionalData));
        const jwe = {
            ciphertext: (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(ciphertext),
            iv: (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(this._iv),
            tag: (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(tag)
        };
        if (encryptedKey) jwe.encrypted_key = (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(encryptedKey);
        if (aadMember) jwe.aad = aadMember;
        if (this._protectedHeader) jwe.protected = (0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(protectedHeader);
        if (this._sharedUnprotectedHeader) jwe.unprotected = this._sharedUnprotectedHeader;
        if (this._unprotectedHeader) jwe.header = this._unprotectedHeader;
        return jwe;
    }
}








class $54e37d233946ddfd$var$IndividualRecipient {
    constructor(enc, key, options){
        this.parent = enc;
        this.key = key;
        this.options = options;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addRecipient(...args) {
        return this.parent.addRecipient(...args);
    }
    encrypt(...args) {
        return this.parent.encrypt(...args);
    }
    done() {
        return this.parent;
    }
}
class $54e37d233946ddfd$export$44234adffc6b0b92 {
    constructor(plaintext){
        this._recipients = [];
        this._plaintext = plaintext;
    }
    addRecipient(key, options) {
        const recipient = new $54e37d233946ddfd$var$IndividualRecipient(this, key, {
            crit: options === null || options === void 0 ? void 0 : options.crit
        });
        this._recipients.push(recipient);
        return recipient;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._unprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    async encrypt(options) {
        var _a, _b, _c;
        if (!this._recipients.length) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("at least one recipient must be added");
        options = {
            deflateRaw: options === null || options === void 0 ? void 0 : options.deflateRaw
        };
        if (this._recipients.length === 1) {
            const [recipient] = this._recipients;
            const flattened = await new (0, $9d1c699dfcbf8bf8$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, {
                ...recipient.options,
                ...options
            });
            let jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [
                    {}
                ],
                tag: flattened.tag
            };
            if (flattened.aad) jwe.aad = flattened.aad;
            if (flattened.protected) jwe.protected = flattened.protected;
            if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
            if (flattened.encrypted_key) jwe.recipients[0].encrypted_key = flattened.encrypted_key;
            if (flattened.header) jwe.recipients[0].header = flattened.header;
            return jwe;
        }
        let enc;
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            if (!(0, $751ed1ebc64f8b96$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, recipient.unprotectedHeader)) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const { alg: alg } = joseHeader;
            if (typeof alg !== "string" || !alg) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            if (alg === "dir" || alg === "ECDH-ES") throw new (0, $599ac781534a947a$export$19f281f2275f6a15)('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            if (typeof joseHeader.enc !== "string" || !joseHeader.enc) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            if (!enc) enc = joseHeader.enc;
            else if (enc !== joseHeader.enc) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            (0, $0b572ece71b785f0$export$2e2bcd8739ae039)((0, $599ac781534a947a$export$19f281f2275f6a15), new Map(), recipient.options.crit, this._protectedHeader, joseHeader);
            if (joseHeader.zip !== undefined) {
                if (!this._protectedHeader || !this._protectedHeader.zip) throw new (0, $599ac781534a947a$export$19f281f2275f6a15)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
            }
        }
        const cek = (0, $723ad0955c3ec8bb$export$2e2bcd8739ae039)(enc);
        let jwe = {
            ciphertext: "",
            iv: "",
            recipients: [],
            tag: ""
        };
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            const target = {};
            jwe.recipients.push(target);
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const p2c = joseHeader.alg.startsWith("PBES2") ? 2048 + i : undefined;
            if (i === 0) {
                const flattened = await new (0, $9d1c699dfcbf8bf8$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).setKeyManagementParameters({
                    p2c: p2c
                }).encrypt(recipient.key, {
                    ...recipient.options,
                    ...options,
                    [(0, $9d1c699dfcbf8bf8$export$39c45cb77eaf132)]: true
                });
                jwe.ciphertext = flattened.ciphertext;
                jwe.iv = flattened.iv;
                jwe.tag = flattened.tag;
                if (flattened.aad) jwe.aad = flattened.aad;
                if (flattened.protected) jwe.protected = flattened.protected;
                if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
                target.encrypted_key = flattened.encrypted_key;
                if (flattened.header) target.header = flattened.header;
                continue;
            }
            const { encryptedKey: encryptedKey, parameters: parameters } = await (0, $b0cae4bcf42b1576$export$2e2bcd8739ae039)(((_a = recipient.unprotectedHeader) === null || _a === void 0 ? void 0 : _a.alg) || ((_b = this._protectedHeader) === null || _b === void 0 ? void 0 : _b.alg) || ((_c = this._unprotectedHeader) === null || _c === void 0 ? void 0 : _c.alg), enc, recipient.key, cek, {
                p2c: p2c
            });
            target.encrypted_key = (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(encryptedKey);
            if (recipient.unprotectedHeader || parameters) target.header = {
                ...recipient.unprotectedHeader,
                ...parameters
            };
        }
        return jwe;
    }
}





function $fd9ff84d4ad74129$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            if ((0, $5852df024b41aa91$export$7b262397cadac19f)() && algorithm.name === "NODE-ED25519") return {
                name: "NODE-ED25519",
                namedCurve: "NODE-ED25519"
            };
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}








function $dd8265016b6a4c59$export$2e2bcd8739ae039(alg, key, usage) {
    if ((0, $3f0b33e7ccc65ae0$export$600b5603bbac4c6)(key)) {
        (0, $bd0b36fb17abf4f5$export$39a36029eee6729)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f)));
        return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $233e587bc0c17441$export$2e2bcd8739ae039)(key, ...(0, $002bdc4a0215a55c$export$b14ad400b1d09e0f), "Uint8Array"));
}


const $dbb3eb797cbe0e44$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $dd8265016b6a4c59$export$2e2bcd8739ae039)(alg, key, "verify");
    (0, $2c8180cef663e103$export$2e2bcd8739ae039)(alg, cryptoKey);
    const algorithm = (0, $fd9ff84d4ad74129$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm);
    try {
        return await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch (_a) {
        return false;
    }
};
var $dbb3eb797cbe0e44$export$2e2bcd8739ae039 = $dbb3eb797cbe0e44$var$verify;









async function $b1a47cad1ba554c8$export$b2614975507c40c9(jws, key, options) {
    var _a;
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jws)) throw new (0, $599ac781534a947a$export$e838de724af3d116)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $599ac781534a947a$export$e838de724af3d116)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jws.header)) throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jws.protected);
        parsedProt = JSON.parse((0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(protectedHeader));
    } catch (_b) {
        throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Protected Header is invalid");
    }
    if (!(0, $751ed1ebc64f8b96$export$2e2bcd8739ae039)(parsedProt, jws.header)) throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $0b572ece71b785f0$export$2e2bcd8739ae039)((0, $599ac781534a947a$export$e838de724af3d116), new Map([
        [
            "b64",
            true
        ]
    ]), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, $599ac781534a947a$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $33550bd8f4719411$export$2e2bcd8739ae039)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $599ac781534a947a$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, $8a5b1565e0dee973$export$2e2bcd8739ae039)(alg, key, "verify");
    const data = (0, $8c3dacf85b96b392$export$ee1b3e54f0441b22)((0, $8c3dacf85b96b392$export$5486af06137bf21a).encode((_a = jws.protected) !== null && _a !== void 0 ? _a : ""), (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode("."), typeof jws.payload === "string" ? (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(jws.payload) : jws.payload);
    const signature = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jws.signature);
    const verified = await (0, $dbb3eb797cbe0e44$export$2e2bcd8739ae039)(alg, key, signature, data);
    if (!verified) throw new (0, $599ac781534a947a$export$c67a0218e7c50378)();
    let payload;
    if (b64) payload = (0, $54a6e0e463467b0a$export$2f872c0f2117be69)(jws.payload);
    else if (typeof jws.payload === "string") payload = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $6446add785626fa5$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(jws);
    if (typeof jws !== "string") throw new (0, $599ac781534a947a$export$e838de724af3d116)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split(".");
    if (length !== 3) throw new (0, $599ac781534a947a$export$e838de724af3d116)("Invalid Compact JWS");
    const verified = await (0, $b1a47cad1ba554c8$export$b2614975507c40c9)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}






async function $65c7a3c0b49d7a21$export$45b643129436bc63(jws, key, options) {
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jws)) throw new (0, $599ac781534a947a$export$e838de724af3d116)("General JWS must be an object");
    if (!Array.isArray(jws.signatures) || !jws.signatures.every((0, $319a04fbce04ffdb$export$2e2bcd8739ae039))) throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Signatures missing or incorrect type");
    for (const signature of jws.signatures)try {
        return await (0, $b1a47cad1ba554c8$export$b2614975507c40c9)({
            header: signature.header,
            payload: jws.payload,
            protected: signature.protected,
            signature: signature.signature
        }, key, options);
    } catch (_a) {}
    throw new (0, $599ac781534a947a$export$c67a0218e7c50378)();
}





var $ca33ae1426f1aba8$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);


const $e00eea37b383aa7e$var$minute = 60;
const $e00eea37b383aa7e$var$hour = $e00eea37b383aa7e$var$minute * 60;
const $e00eea37b383aa7e$var$day = $e00eea37b383aa7e$var$hour * 24;
const $e00eea37b383aa7e$var$week = $e00eea37b383aa7e$var$day * 7;
const $e00eea37b383aa7e$var$year = $e00eea37b383aa7e$var$day * 365.25;
const $e00eea37b383aa7e$var$REGEX = /^(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)$/i;
var $e00eea37b383aa7e$export$2e2bcd8739ae039 = (str)=>{
    const matched = $e00eea37b383aa7e$var$REGEX.exec(str);
    if (!matched) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[1]);
    const unit = matched[2].toLowerCase();
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            return Math.round(value);
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            return Math.round(value * $e00eea37b383aa7e$var$minute);
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            return Math.round(value * $e00eea37b383aa7e$var$hour);
        case "day":
        case "days":
        case "d":
            return Math.round(value * $e00eea37b383aa7e$var$day);
        case "week":
        case "weeks":
        case "w":
            return Math.round(value * $e00eea37b383aa7e$var$week);
        default:
            return Math.round(value * $e00eea37b383aa7e$var$year);
    }
};



const $b4d6c2e00c056d92$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const $b4d6c2e00c056d92$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $b4d6c2e00c056d92$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || $b4d6c2e00c056d92$var$normalizeTyp(protectedHeader.typ) !== $b4d6c2e00c056d92$var$normalizeTyp(typ))) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('unexpected "typ" JWT header value', "typ", "check_failed");
    let payload;
    try {
        payload = JSON.parse((0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(encodedPayload));
    } catch (_a) {}
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(payload)) throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("JWT Claims Set must be a top-level JSON object");
    const { issuer: issuer } = options;
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('unexpected "iss" claim value', "iss", "check_failed");
    const { subject: subject } = options;
    if (subject && payload.sub !== subject) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('unexpected "sub" claim value', "sub", "check_failed");
    const { audience: audience } = options;
    if (audience && !$b4d6c2e00c056d92$var$checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('unexpected "aud" claim value', "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, $e00eea37b383aa7e$export$2e2bcd8739ae039)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: currentDate } = options;
    const now = (0, $ca33ae1426f1aba8$export$2e2bcd8739ae039)(currentDate || new Date());
    if ((payload.iat !== undefined || options.maxTokenAge) && typeof payload.iat !== "number") throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"iat" claim must be a number', "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"nbf" claim must be a number', "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"nbf" claim timestamp check failed', "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"exp" claim must be a number', "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, $599ac781534a947a$export$4b386bf852b7863d)('"exp" claim timestamp check failed', "exp", "check_failed");
    }
    if (options.maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof options.maxTokenAge === "number" ? options.maxTokenAge : (0, $e00eea37b383aa7e$export$2e2bcd8739ae039)(options.maxTokenAge);
        if (age - tolerance > max) throw new (0, $599ac781534a947a$export$4b386bf852b7863d)('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
    }
    return payload;
};



async function $059e3a140d30ed13$export$c878fd0f8381da51(jwt, key, options) {
    var _a;
    const verified = await (0, $6446add785626fa5$export$996150e72a8992e)(jwt, key, options);
    if (((_a = verified.protectedHeader.crit) === null || _a === void 0 ? void 0 : _a.includes("b64")) && verified.protectedHeader.b64 === false) throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
    const payload = (0, $b4d6c2e00c056d92$export$2e2bcd8739ae039)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}





async function $dabb925293a77b9d$export$6ee899505bc40a19(jwt, key, options) {
    const decrypted = await (0, $1b1a9f568583dcab$export$c9a8efe6bfd872ce)(jwt, key, options);
    const payload = (0, $b4d6c2e00c056d92$export$2e2bcd8739ae039)(decrypted.protectedHeader, decrypted.plaintext, options);
    const { protectedHeader: protectedHeader } = decrypted;
    if (protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('replicated "iss" claim header parameter mismatch', "iss", "mismatch");
    if (protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('replicated "sub" claim header parameter mismatch', "sub", "mismatch");
    if (protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud)) throw new (0, $599ac781534a947a$export$f1e14efb908196e9)('replicated "aud" claim header parameter mismatch', "aud", "mismatch");
    const result = {
        payload: payload,
        protectedHeader: protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}



class $960dbbe2ca85a5d4$export$965e4de9938e070e {
    constructor(plaintext){
        this._flattened = new (0, $9d1c699dfcbf8bf8$export$eec23736d3c24809)(plaintext);
    }
    setContentEncryptionKey(cek) {
        this._flattened.setContentEncryptionKey(cek);
        return this;
    }
    setInitializationVector(iv) {
        this._flattened.setInitializationVector(iv);
        return this;
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    setKeyManagementParameters(parameters) {
        this._flattened.setKeyManagementParameters(parameters);
        return this;
    }
    async encrypt(key, options) {
        const jwe = await this._flattened.encrypt(key, options);
        return [
            jwe.protected,
            jwe.encrypted_key,
            jwe.iv,
            jwe.ciphertext,
            jwe.tag
        ].join(".");
    }
}








const $af54292801bcc1f9$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $dd8265016b6a4c59$export$2e2bcd8739ae039)(alg, key, "sign");
    (0, $2c8180cef663e103$export$2e2bcd8739ae039)(alg, cryptoKey);
    const signature = await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.sign((0, $fd9ff84d4ad74129$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $af54292801bcc1f9$export$2e2bcd8739ae039 = $af54292801bcc1f9$var$sign;







class $ef6876836c58b0e4$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $599ac781534a947a$export$e838de724af3d116)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, $751ed1ebc64f8b96$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $599ac781534a947a$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $0b572ece71b785f0$export$2e2bcd8739ae039)((0, $599ac781534a947a$export$e838de724af3d116), new Map([
            [
                "b64",
                true
            ]
        ]), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, $599ac781534a947a$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $599ac781534a947a$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $8a5b1565e0dee973$export$2e2bcd8739ae039)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode((0, $54a6e0e463467b0a$export$c564cdbbe6da493)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode((0, $54a6e0e463467b0a$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode("");
        const data = (0, $8c3dacf85b96b392$export$ee1b3e54f0441b22)(protectedHeader, (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode("."), payload);
        const signature = await (0, $af54292801bcc1f9$export$2e2bcd8739ae039)(alg, key, data);
        const jws = {
            signature: (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(protectedHeader);
        return jws;
    }
}


class $12d745ca26469470$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $ef6876836c58b0e4$export$9a8af5200da5ddb1)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}





class $bd5afc6fb4098417$var$IndividualSignature {
    constructor(sig, key, options){
        this.parent = sig;
        this.key = key;
        this.options = options;
    }
    setProtectedHeader(protectedHeader) {
        if (this.protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this.protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addSignature(...args) {
        return this.parent.addSignature(...args);
    }
    sign(...args) {
        return this.parent.sign(...args);
    }
    done() {
        return this.parent;
    }
}
class $bd5afc6fb4098417$export$7e2f94727ed1a34b {
    constructor(payload){
        this._signatures = [];
        this._payload = payload;
    }
    addSignature(key, options) {
        const signature = new $bd5afc6fb4098417$var$IndividualSignature(this, key, options);
        this._signatures.push(signature);
        return signature;
    }
    async sign() {
        if (!this._signatures.length) throw new (0, $599ac781534a947a$export$e838de724af3d116)("at least one signature must be added");
        const jws = {
            signatures: [],
            payload: ""
        };
        for(let i = 0; i < this._signatures.length; i++){
            const signature = this._signatures[i];
            const flattened = new (0, $ef6876836c58b0e4$export$9a8af5200da5ddb1)(this._payload);
            flattened.setProtectedHeader(signature.protectedHeader);
            flattened.setUnprotectedHeader(signature.unprotectedHeader);
            const { payload: payload, ...rest } = await flattened.sign(signature.key, signature.options);
            if (i === 0) jws.payload = payload;
            else if (jws.payload !== payload) throw new (0, $599ac781534a947a$export$e838de724af3d116)("inconsistent use of JWS Unencoded Payload Option (RFC7797)");
            jws.signatures.push(rest);
        }
        return jws;
    }
}








class $46f2da2b3de4ed34$export$2ef1b74b7c7e6eb3 {
    constructor(payload){
        if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: input
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $ca33ae1426f1aba8$export$2e2bcd8739ae039)(new Date()) + (0, $e00eea37b383aa7e$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: input
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $ca33ae1426f1aba8$export$2e2bcd8739ae039)(new Date()) + (0, $e00eea37b383aa7e$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, $ca33ae1426f1aba8$export$2e2bcd8739ae039)(new Date())
        };
        else this._payload = {
            ...this._payload,
            iat: input
        };
        return this;
    }
}


class $cb3fa919fa1549c0$export$88d4e5d23fbe6c84 extends (0, $46f2da2b3de4ed34$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        var _a;
        const sig = new (0, $12d745ca26469470$export$b6738d8e70498d17)((0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray((_a = this._protectedHeader) === null || _a === void 0 ? void 0 : _a.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}





class $0c71009a661b4763$export$28c9f8d29aec6f3d extends (0, $46f2da2b3de4ed34$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    replicateIssuerAsHeader() {
        this._replicateIssuerAsHeader = true;
        return this;
    }
    replicateSubjectAsHeader() {
        this._replicateSubjectAsHeader = true;
        return this;
    }
    replicateAudienceAsHeader() {
        this._replicateAudienceAsHeader = true;
        return this;
    }
    async encrypt(key, options) {
        const enc = new (0, $960dbbe2ca85a5d4$export$965e4de9938e070e)((0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        if (this._replicateIssuerAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            iss: this._payload.iss
        };
        if (this._replicateSubjectAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            sub: this._payload.sub
        };
        if (this._replicateAudienceAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            aud: this._payload.aud
        };
        enc.setProtectedHeader(this._protectedHeader);
        if (this._iv) enc.setInitializationVector(this._iv);
        if (this._cek) enc.setContentEncryptionKey(this._cek);
        if (this._keyManagementParameters) enc.setKeyManagementParameters(this._keyManagementParameters);
        return enc.encrypt(key, options);
    }
}







const $21a28d57e89a027d$var$check = (value, description)=>{
    if (typeof value !== "string" || !value) throw new (0, $599ac781534a947a$export$b3992e0f88fb07e3)(`${description} missing or invalid`);
};
async function $21a28d57e89a027d$export$f1ec189735e8660f(jwk, digestAlgorithm) {
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = "sha256";
    if (digestAlgorithm !== "sha256" && digestAlgorithm !== "sha384" && digestAlgorithm !== "sha512") throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
    let components;
    switch(jwk.kty){
        case "EC":
            $21a28d57e89a027d$var$check(jwk.crv, '"crv" (Curve) Parameter');
            $21a28d57e89a027d$var$check(jwk.x, '"x" (X Coordinate) Parameter');
            $21a28d57e89a027d$var$check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case "OKP":
            $21a28d57e89a027d$var$check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            $21a28d57e89a027d$var$check(jwk.x, '"x" (Public Key) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case "RSA":
            $21a28d57e89a027d$var$check(jwk.e, '"e" (Exponent) Parameter');
            $21a28d57e89a027d$var$check(jwk.n, '"n" (Modulus) Parameter');
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        case "oct":
            $21a28d57e89a027d$var$check(jwk.k, '"k" (Key Value) Parameter');
            components = {
                k: jwk.k,
                kty: jwk.kty
            };
            break;
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('"kty" (Key Type) Parameter missing or unsupported');
    }
    const data = (0, $8c3dacf85b96b392$export$5486af06137bf21a).encode(JSON.stringify(components));
    return (0, $54a6e0e463467b0a$export$c564cdbbe6da493)(await (0, $491757e359519ceb$export$2e2bcd8739ae039)(digestAlgorithm, data));
}
async function $21a28d57e89a027d$export$b9879ebc49d4fd7a(jwk, digestAlgorithm) {
    digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = "sha256";
    const thumbprint = await $21a28d57e89a027d$export$f1ec189735e8660f(jwk, digestAlgorithm);
    return `urn:ietf:params:oauth:jwk-thumbprint:sha-${digestAlgorithm.slice(-3)}:${thumbprint}`;
}





async function $ca86cc6e287c4a76$export$c51e3062a159ef59(protectedHeader, token) {
    const joseHeader = {
        ...protectedHeader,
        ...token === null || token === void 0 ? void 0 : token.header
    };
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(joseHeader.jwk)) throw new (0, $599ac781534a947a$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a JSON object');
    const key = await (0, $d3f3b992c534ed5a$export$2b70d37b4d0b888b)({
        ...joseHeader.jwk,
        ext: true
    }, joseHeader.alg, true);
    if (key instanceof Uint8Array || key.type !== "public") throw new (0, $599ac781534a947a$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a public key');
    return key;
}





function $34d7790339015997$var$getKtyFromAlg(alg) {
    switch(typeof alg === "string" && alg.slice(0, 2)){
        case "RS":
        case "PS":
            return "RSA";
        case "ES":
            return "EC";
        case "Ed":
            return "OKP";
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $34d7790339015997$export$d01e0ebadbb4baf(jwks) {
    return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every($34d7790339015997$var$isJWKLike);
}
function $34d7790339015997$var$isJWKLike(key) {
    return (0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(key);
}
function $34d7790339015997$var$clone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $34d7790339015997$export$cfeaec9a672ea12b {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$34d7790339015997$export$d01e0ebadbb4baf(jwks)) throw new (0, $599ac781534a947a$export$9b22c2a1e2403b8e)("JSON Web Key Set malformed");
        this._jwks = $34d7790339015997$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token === null || token === void 0 ? void 0 : token.header
        };
        const kty = $34d7790339015997$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === "string") candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === "string") candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === "string") candidate = jwk.use === "sig";
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes("verify");
            if (candidate && alg === "EdDSA") candidate = jwk.crv === "Ed25519" || jwk.crv === "Ed448";
            if (candidate) switch(alg){
                case "ES256":
                    candidate = jwk.crv === "P-256";
                    break;
                case "ES256K":
                    candidate = jwk.crv === "secp256k1";
                    break;
                case "ES384":
                    candidate = jwk.crv === "P-384";
                    break;
                case "ES512":
                    candidate = jwk.crv === "P-521";
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $599ac781534a947a$export$3d5ed1a538bed04e)();
        else if (length !== 1) {
            const error = new (0, $599ac781534a947a$export$dc036de401a5c284)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $34d7790339015997$var$importWithAlgCache(_cached, jwk, alg);
                } catch (_a) {
                    continue;
                }
            };
            throw error;
        }
        return $34d7790339015997$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $34d7790339015997$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $d3f3b992c534ed5a$export$2b70d37b4d0b888b)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== "public") throw new (0, $599ac781534a947a$export$9b22c2a1e2403b8e)("JSON Web Key Set members must be public keys");
        cached[alg] = key;
    }
    return cached[alg];
}
function $34d7790339015997$export$4892abc640e5f80e(jwks) {
    const set = new $34d7790339015997$export$cfeaec9a672ea12b(jwks);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}



const $22e7f56c38b2bd5a$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === "function") {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: "manual",
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $599ac781534a947a$export$3f30acebf25c04e6)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $599ac781534a947a$export$f754d6850d76bf87)("Expected 200 OK from the JSON Web Key Set HTTP response");
    try {
        return await response.json();
    } catch (_a) {
        throw new (0, $599ac781534a947a$export$f754d6850d76bf87)("Failed to parse the JSON Web Key Set HTTP response as JSON");
    }
};
var $22e7f56c38b2bd5a$export$2e2bcd8739ae039 = $22e7f56c38b2bd5a$var$fetchJwks;





class $3c97161a25c83f88$var$RemoteJWKSet extends (0, $34d7790339015997$export$cfeaec9a672ea12b) {
    constructor(url, options){
        super({
            keys: []
        });
        this._jwks = undefined;
        if (!(url instanceof URL)) throw new TypeError("url must be an instance of URL");
        this._url = new URL(url.href);
        this._options = {
            agent: options === null || options === void 0 ? void 0 : options.agent,
            headers: options === null || options === void 0 ? void 0 : options.headers
        };
        this._timeoutDuration = typeof (options === null || options === void 0 ? void 0 : options.timeoutDuration) === "number" ? options === null || options === void 0 ? void 0 : options.timeoutDuration : 5000;
        this._cooldownDuration = typeof (options === null || options === void 0 ? void 0 : options.cooldownDuration) === "number" ? options === null || options === void 0 ? void 0 : options.cooldownDuration : 30000;
        this._cacheMaxAge = typeof (options === null || options === void 0 ? void 0 : options.cacheMaxAge) === "number" ? options === null || options === void 0 ? void 0 : options.cacheMaxAge : 600000;
    }
    coolingDown() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._jwks || !this.fresh()) await this.reload();
        try {
            return await super.getKey(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $599ac781534a947a$export$3d5ed1a538bed04e)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return super.getKey(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && (0, $5852df024b41aa91$export$7b262397cadac19f)()) this._pendingFetch = undefined;
        this._pendingFetch || (this._pendingFetch = (0, $22e7f56c38b2bd5a$export$2e2bcd8739ae039)(this._url, this._timeoutDuration, this._options).then((json)=>{
            if (!(0, $34d7790339015997$export$d01e0ebadbb4baf)(json)) throw new (0, $599ac781534a947a$export$9b22c2a1e2403b8e)("JSON Web Key Set malformed");
            this._jwks = {
                keys: json.keys
            };
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $3c97161a25c83f88$export$78ce35c2df51c333(url, options) {
    const set = new $3c97161a25c83f88$var$RemoteJWKSet(url, options);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}







class $77e6b4edfb8cf2f7$export$6404fb90f16d8733 extends (0, $46f2da2b3de4ed34$export$2ef1b74b7c7e6eb3) {
    encode() {
        const header = $54a6e0e463467b0a$export$c564cdbbe6da493(JSON.stringify({
            alg: "none"
        }));
        const payload = $54a6e0e463467b0a$export$c564cdbbe6da493(JSON.stringify(this._payload));
        return `${header}.${payload}.`;
    }
    static decode(jwt, options) {
        if (typeof jwt !== "string") throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("Unsecured JWT must be a string");
        const { 0: encodedHeader, 1: encodedPayload, 2: signature, length: length } = jwt.split(".");
        if (length !== 3 || signature !== "") throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        let header;
        try {
            header = JSON.parse((0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode($54a6e0e463467b0a$export$2f872c0f2117be69(encodedHeader)));
            if (header.alg !== "none") throw new Error();
        } catch (_a) {
            throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        }
        const payload = (0, $b4d6c2e00c056d92$export$2e2bcd8739ae039)(header, $54a6e0e463467b0a$export$2f872c0f2117be69(encodedPayload), options);
        return {
            payload: payload,
            header: header
        };
    }
}





const $037928530fb1a7c6$export$c564cdbbe6da493 = $54a6e0e463467b0a$export$c564cdbbe6da493;
const $037928530fb1a7c6$export$2f872c0f2117be69 = $54a6e0e463467b0a$export$2f872c0f2117be69;




function $bebad503ff32169d$export$ca23208356ba8d90(token) {
    let protectedB64u;
    if (typeof token === "string") {
        const parts = token.split(".");
        if (parts.length === 3 || parts.length === 5) [protectedB64u] = parts;
    } else if (typeof token === "object" && token) {
        if ("protected" in token) protectedB64u = token.protected;
        else throw new TypeError("Token does not contain a Protected Header");
    }
    try {
        if (typeof protectedB64u !== "string" || !protectedB64u) throw new Error();
        const result = JSON.parse((0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode((0, $037928530fb1a7c6$export$2f872c0f2117be69)(protectedB64u)));
        if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(result)) throw new Error();
        return result;
    } catch (_a) {
        throw new TypeError("Invalid Token or Protected Header formatting");
    }
}






function $8450eca62cfceb24$export$dcef71b8fb9a6794(jwt) {
    if (typeof jwt !== "string") throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("JWTs must use Compact JWS serialization, JWT must be a string");
    const { 1: payload, length: length } = jwt.split(".");
    if (length === 5) throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("Only JWTs using Compact JWS serialization can be decoded");
    if (length !== 3) throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("Invalid JWT");
    if (!payload) throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("JWTs must contain a payload");
    let decoded;
    try {
        decoded = (0, $037928530fb1a7c6$export$2f872c0f2117be69)(payload);
    } catch (_a) {
        throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("Failed to parse the base64url encoded payload");
    }
    let result;
    try {
        result = JSON.parse((0, $8c3dacf85b96b392$export$124c96e6ce37090b).decode(decoded));
    } catch (_b) {
        throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("Failed to parse the decoded payload as JSON");
    }
    if (!(0, $319a04fbce04ffdb$export$2e2bcd8739ae039)(result)) throw new (0, $599ac781534a947a$export$936b39ada0bbfceb)("Invalid JWT Claims Set");
    return result;
}







async function $27e8ab24924f68d3$export$25395fe8d170ad7(alg, options) {
    var _a;
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, $add6505a95ba3e92$export$2e2bcd8739ae039)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length: length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length: length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.generateKey(algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages);
}
function $27e8ab24924f68d3$var$getModulusLengthOption(options) {
    var _a;
    const modulusLength = (_a = options === null || options === void 0 ? void 0 : options.modulusLength) !== null && _a !== void 0 ? _a : 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function $27e8ab24924f68d3$export$a949d36eab55b41f(alg, options) {
    var _a, _b, _c, _d;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $27e8ab24924f68d3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $27e8ab24924f68d3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $27e8ab24924f68d3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            keyUsages = [
                "sign",
                "verify"
            ];
            const crv = (_a = options === null || options === void 0 ? void 0 : options.crv) !== null && _a !== void 0 ? _a : "Ed25519";
            switch(crv){
                case "Ed25519":
                case "Ed448":
                    algorithm = {
                        name: crv
                    };
                    break;
                default:
                    throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided");
            }
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = (_b = options === null || options === void 0 ? void 0 : options.crv) !== null && _b !== void 0 ? _b : "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, $599ac781534a947a$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    try {
        return await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.generateKey(algorithm, (_c = options === null || options === void 0 ? void 0 : options.extractable) !== null && _c !== void 0 ? _c : false, keyUsages);
    } catch (err) {
        if (algorithm.name === "Ed25519" && (err === null || err === void 0 ? void 0 : err.name) === "NotSupportedError" && (0, $5852df024b41aa91$export$7b262397cadac19f)()) {
            algorithm = {
                name: "NODE-ED25519",
                namedCurve: "NODE-ED25519"
            };
            return await (0, $3f0b33e7ccc65ae0$export$2e2bcd8739ae039).subtle.generateKey(algorithm, (_d = options === null || options === void 0 ? void 0 : options.extractable) !== null && _d !== void 0 ? _d : false, keyUsages);
        }
        throw err;
    }
}


async function $fac953757d12c296$export$a949d36eab55b41f(alg, options) {
    return (0, $27e8ab24924f68d3$export$a949d36eab55b41f)(alg, options);
}



async function $32b2e4a7f1f02d78$export$25395fe8d170ad7(alg, options) {
    return (0, $27e8ab24924f68d3$export$25395fe8d170ad7)(alg, options);
}





function $295d08103c698a2a$var$createDataValue(idToken, field) {
    const value = document.createElement("p");
    value.className = "jwt-data-value";
    value.textContent = `${idToken[field]}`;
    return value;
}
function $295d08103c698a2a$var$createDataRow(field) {
    const name = document.createElement("p");
    name.className = "jwt-data-name";
    name.textContent = `${field}:`;
    return name;
}
function $295d08103c698a2a$var$renderIdTokenContents() {
    const idTokenQueryParam = new URLSearchParams(window.location.search).get("id_token");
    if (!idTokenQueryParam) return;
    const idToken = $8450eca62cfceb24$export$dcef71b8fb9a6794(idTokenQueryParam);
    const container = document.getElementById("jwt-container");
    const header = document.createElement("h2");
    header.textContent = "ID-token contents";
    container.append(header);
    for(const field in idToken){
        const name = $295d08103c698a2a$var$createDataRow(field);
        const value = $295d08103c698a2a$var$createDataValue(idToken, field);
        const br = document.createElement("br");
        container.append(name);
        container.append(value);
        container.append(br);
    }
}
function $295d08103c698a2a$var$renderButtons() {
    const idTokenQueryParam = new URLSearchParams(window.location.search).get("id_token");
    if (!idTokenQueryParam) {
        document.getElementById("logout").style.display = "none";
        return;
    }
    document.getElementById("login").style.display = "none";
}
$295d08103c698a2a$var$renderIdTokenContents();
$295d08103c698a2a$var$renderButtons();


//# sourceMappingURL=index.6d9657b5.js.map
